const jsonSchema = [
  {
    type: 'group',
    fields: [
      {
        name: 'shared',
        label: 'Shared',
        type: 'checkbox',
        isChecked: true,
        required: true
      },
      {
        name: 'dueDate',
        label: 'Due Date',
        type: 'date',
        required: true
      }
    ]
  },
  {
    name: 'reviewer',
    label: 'Reviewer',
    type: 'multiselect',
    showInList: true,
    isMulti: false,
    required: true
  },
  {
    name: 'employee',
    label: 'Employee',
    required: true,
    showInList: true,
    type: 'multiselect',
    isMulti: false
  },
  {
    name: 'performanceEvaluation',
    label:
      'How would you evaluate their overall performance in their given role? *',
    type: 'textarea',
    required: true
  },
  {
    name: 'knowledge',
    label:
      'How effectively do they demonstrate knowledge & skills to successfully achieve their goals?',
    type: 'textarea',
    required: true
  },
  {
    name: 'collaborations',
    label: 'How well do they collaborate with others?',
    type: 'textarea',
    required: true
  },
  {
    name: 'trends',
    label: 'How well do they apply the latest industry trends to their work?',
    type: 'textarea',
    required: true
  },
  {
    name: 'comments',
    label: 'Other comments',
    type: 'textarea',
    required: false
  },
  {
    name: 'sentimentScore',
    label: 'Sentiment Score',
    type: 'range',
    maxWidth: '50%',
    required: true,
    showInList: true
  }
];
export default jsonSchema;
